<template>
  <v-container fluid>
    <v-loading v-if="loading" />
    <page-404 v-if="!correct_route && !loading" message="کاربر مورد نظر یافت نشد!!!" />
    <v-layout v-if="correct_route && !loading" row wrap class="white pa-4">
      <v-flex xs12>
        <div
          class="text-xs-center text-xs-right"
          :style="$vuetify.breakpoint.smAndUp ? 'display: flex':''"
        >
          <!--user image-->
          <v-avatar tile size="130px" slot="activator">
            <img :src="user.image" class="allLineBorder" />
          </v-avatar>
          <div>
            <v-card-text :class="$vuetify.breakpoint.smAndUp ? 'pt-5 pb-0':'pt-1 pb-0'">
              <div>
                <div class="pb-1">{{user.name}}</div>
                <div>{{user.email}}</div>
                <div>
                  <span>{{getRoleName(user.roles)}}</span>
                </div>
              </div>
            </v-card-text>
          </div>
        </div>
      </v-flex>
      <!--tabs-->
      <v-flex xs12 mt-4>
        <v-tabs
          class="r5"
          color="grey6"
          :ripple="false"
          :scrollable="false"
          slider-color="primary darken-1"
          active-class="v-tabs__item--active primary cr-team-shadow white--text"
        >
          <v-tab class>{{$t('history')}}</v-tab>
          <v-spacer />
        </v-tabs>
        <!--tabs content-->
        <v-tabs-items>
          <v-tab-item lazy style="padding:1px" class="pt-2">
            <activityLog :user_id="user.id" :userName="user.name" ref="tbl" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import activityLog from "./ActivityLog";

export default {
  components: { activityLog },
  data() {
    return {
      search: null,
      loading: true,
      correct_route: true,
      user: {
        id: "",
        name: "",
        email: "",
        roles: [],
        image: require("@/assets/images/userplaceholder.svg")
      }
    };
  },
  methods: {
    printTable(excel) {
      this.$refs.tbl.printTable(excel);
    },
    getRoleName(roles) {
      let a = "";
      let len = roles.length;
      for (let i = 0; i < len; i++) {
        a = a + roles[i].name;
        if (i !== len - 1) {
          a = a + ", ";
        }
      }
      return a;
    }
  },
  created() {
    let id = this.$store.state.route.params.id;
    this.axios
      .get("users/" + id)
      .then(response => {
        this.user = response.data;
        this.correct_route = true;
        this.loading = false;
      })
      .catch(error => {
        this.correct_route = false;
        this.loading = false;
      });
  }
};
</script>